import {
    ClientWithContacts,
    findClientContactByRole,
    ClientContactLike,
    contactDisplayName,
} from './clientContacts';

export type QuoteRecipientOption = {
    email: string;
    label: string;
    role?: string;
    isPrimary?: boolean;
};

/**
 * Prefill To: facturation → administratif → client.email
 */
export function defaultQuoteRecipientEmail(client: ClientWithContacts | null | undefined): string {
    const facturation = findClientContactByRole(client, 'facturation');
    if (facturation?.email)
        return String(facturation.email).trim();

    const administratif = findClientContactByRole(client, 'administratif');
    if (administratif?.email)
        return String(administratif.email).trim();

    return String(client?.email || '').trim();
}

export function quoteRecipientOptions(client: ClientWithContacts | null | undefined): QuoteRecipientOption[] {
    const options: QuoteRecipientOption[] = [];
    const seen = new Set<string>();

    const push = (email: string, label: string, role?: string, isPrimary?: boolean) => {
        const normalized = email.trim().toLowerCase();
        if (!normalized || seen.has(normalized))
            return;
        seen.add(normalized);
        options.push({ email: email.trim(), label, role, isPrimary });
    };

    if (client?.email) {
        const name = [client.firstname, client.lastname].filter(Boolean).join(' ').trim();
        push(client.email, name || client.email, undefined, true);
    }

    (client?.contacts || []).forEach((contact: ClientContactLike) => {
        const email = String(contact.email || '').trim();
        if (!email)
            return;
        const name = contactDisplayName(contact) || email;
        const role = (contact.roles || [])[0];
        push(email, name, role ? String(role) : undefined);
    });

    return options;
}
